import dateFormat from 'date-fns/format';
import dateRU from 'date-fns/locale/ru';
import { VIEW_DATE_FORMAT } from "../constants";
import parseDate from "./parseDate";

const options = { locale: dateRU };

const formatDate = (date: null | Date | string, format = VIEW_DATE_FORMAT) => {
  date = parseDate(date);
  if (!date || Number.isNaN(+date)) return null;
  return dateFormat(date, format, options);
};

export default formatDate;
